import { render, staticRenderFns } from "./CustomSuggestionInput.vue?vue&type=template&id=4f411eb6&"
import script from "./CustomSuggestionInput.vue?vue&type=script&lang=js&"
export * from "./CustomSuggestionInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomSuggestionInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports